import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function errMsg(e, fallback = "Bir hata oluştu. Lütfen tekrar deneyin.") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return fallback;
}

export function useApi(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const load = useCallback(async () => {
    setError(null);
    try {
      const r = await api.get(path);
      setData(r.data);
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [path]);
  useEffect(() => {
    load();
  }, [load]);
  return { data, loading, error, reload: load };
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric" }) : "—");

export const BRAND = {
  phone: "+90 (533) 324 81 99",
  phoneHref: "tel:+905333248199",
  email: "bilgi@skenstitu.com",
  wa: "https://wa.me/905333248199?text=Merhaba%2C%20e%C4%9Fitim%20programlar%C4%B1%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.",
};
